import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { HamButtonComponent } from '@modeso/aumico-components';
import { TierDto } from '../../dtos/organizationSearchDto.interface';

@Component({
    selector: 'tier-filter-drop-down',
    templateUrl: './tier-filter-drop-down.component.html',
    styleUrls: ['./tier-filter-drop-down.component.scss'],
})
export class TierFilterDropDownComponent {
    @Input() selectedTiers: TierDto[] = [];
    @Output() tierChange = new EventEmitter<TierDto[]>();

    openedFlyout = false;
    @Input() rightAlignment: boolean = false;
    flyoutPosition: { top: number; left: number; right: number } = { top: 0, left: 0, right: 0 };

    statusOptions = Object.values(TierDto).map((tier) => ({ label: tier, value: tier }));
    @Input() singleSelection = false;

    isFilterActive: boolean = this.selectedTiers.length > 0;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedTiers']) {
            this.isFilterActive = this.selectedTiers && this.selectedTiers.length > 0;
        }
    }

    toggleTierSelection(value: TierDto): void {
        if (this.singleSelection) {
            this.selectedTiers = [value];
            this.applyFilter();
            return;
        }

        const isCurrentlySelected = this.selectedTiers.includes(value);
        this.onTierSelection(value, !isCurrentlySelected);
    }

    onTierSelection(value: TierDto, checked: boolean) {
        if (this.singleSelection) {
            this.selectedTiers = [];
            this.selectedTiers.push(value);
            this.applyFilter();
            return;
        }

        if (checked) {
            this.selectedTiers.push(value);
        } else {
            this.selectedTiers = this.selectedTiers.filter((v) => v !== value);
        }
    }

    openFlyout(buttonComponent: HamButtonComponent): void {
        const buttonElement = buttonComponent.nativeButton?.nativeElement;

        if (!buttonElement) return;

        const rect = buttonElement.getBoundingClientRect();

        this.flyoutPosition = {
            top: rect.bottom + 8,
            right: rect.right,
            left: rect.left,
        };

        const diffrence = rect.left - rect.right;

        if (this.rightAlignment) {
            this.flyoutPosition.left += diffrence;
        }

        this.openedFlyout = true;
    }

    closeFlyout(): void {
        this.openedFlyout = false;
    }

    applyFilter(): void {
        this.isFilterActive = this.selectedTiers.length > 0;
        this.closeFlyout();
        this.tierChange.emit(this.selectedTiers);
    }

    clearFilter(): void {
        this.selectedTiers = [];
        this.isFilterActive = false;
        this.closeFlyout();
        this.tierChange.emit(this.selectedTiers);
    }
}
